import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class MLProducerEligibilityService {
    static isProducerCodeEligible(req, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('agentproducereligibility'),
            'isProducerCodeEligible', [req], additionalHeaders);
    }
}
